import { PLANET_GLYPHS, PLANET_EN_ES, SIGN_EN_ES, ZODIAC_GLYPHS, ASPECT_EN_ES } from "../lib/api";

export default function ChartPlacements({ chart }) {
  return (
    <div data-testid="carta-placements" className="mb-12">
      <p className="overline mb-2">Posiciones planetarias</p>
      <div className="mt-4 space-y-1">
        {chart.planets.map((p) => (
          <div key={p.planet} data-testid={`placement-${p.planet.toLowerCase()}`}
            className="flex items-center justify-between py-2 border-b border-white/5">
            <div className="flex items-center gap-3">
              <span className="text-[#C9A25E] text-xl w-7 text-center">{PLANET_GLYPHS[p.planet]}</span>
              <span className="text-white">{PLANET_EN_ES[p.planet]}</span>
              {p.retrograde && <span className="text-xs text-zinc-500">℞</span>}
            </div>
            <div className="text-right">
              <div className="text-white text-sm">
                <span className="text-[#C9A25E] mr-2">{ZODIAC_GLYPHS[p.sign]}</span>
                {SIGN_EN_ES[p.sign]} <span className="text-zinc-500 text-xs">{p.degree}°</span>
              </div>
              <div className="text-xs text-zinc-500">Casa {p.house}</div>
            </div>
          </div>
        ))}
      </div>
      <p className="overline mt-6 mb-2">Aspectos mayores</p>
      <div data-testid="carta-aspects" className="grid grid-cols-2 gap-2">
        {chart.aspects.map((a, i) => (
          <div key={i} className="text-xs text-zinc-400 py-1">
            <span className="text-white">{PLANET_EN_ES[a.planet1]}</span>
            <span className="mx-2 text-[#C9A25E]">{ASPECT_EN_ES[a.aspect]}</span>
            <span className="text-white">{PLANET_EN_ES[a.planet2]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
